import { render, staticRenderFns } from "./ControleAnuncios.vue?vue&type=template&id=f2bc1220&"
import script from "./ControleAnuncios.vue?vue&type=script&lang=js&"
export * from "./ControleAnuncios.vue?vue&type=script&lang=js&"
import style0 from "./ControleAnuncios.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports